const stats = [
  { value: '500万+', label: '全球玩家信赖' },
  { value: '100+', label: '精选游戏' },
  { value: '99.9%', label: '平台稳定率' },
  { value: '24H', label: '全天候服务' },
];

export default function HomeStats() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}